/**
 * Mirror backend cms.member_employment.member_was_active_in_calendar_month.
 */

function parseMonthKey(monthKey) {
  const parts = String(monthKey || "")
    .trim()
    .split("-");
  if (parts.length !== 2) return null;
  const y = Number(parts[0]);
  const mo = Number(parts[1]);
  if (!Number.isFinite(y) || !Number.isFinite(mo) || mo < 1 || mo > 12) {
    return null;
  }
  return {y, mo};
}

function monthBounds(monthKey) {
  const parsed = parseMonthKey(monthKey);
  if (!parsed) return {firstDay: null, lastDay: null};
  const {y, mo} = parsed;
  const lastDate = new Date(y, mo, 0);
  const firstDate = new Date(y, mo - 1, 1);
  return {
    firstDay: firstDate,
    lastDay: lastDate,
  };
}

function parseIsoDate(value) {
  if (!value) return null;
  const s = String(value).slice(0, 10);
  const [y, mo, d] = s.split("-").map(Number);
  if (!y || !mo || !d) return null;
  return new Date(y, mo - 1, d);
}

/**
 * @param {object} member team row or synthetic row
 * @param {string} monthKey YYYY-MM
 */
export function memberWasActiveInCalendarMonth(member, monthKey) {
  if (!member || !monthKey) return true;
  const {firstDay, lastDay} = monthBounds(monthKey);
  if (!firstDay || !lastDay) return true;

  const stintStart = parseIsoDate(member.current_employment_start_date);
  if (stintStart && stintStart > lastDay) return false;

  if (member.is_currently_working !== false) return true;

  const lastWork = parseIsoDate(member.last_working_date);
  if (!lastWork) return true;

  return lastWork >= firstDay;
}

/**
 * Payroll 出勤簿: include only members employed during `monthKey`.
 * Uses backend `is_currently_working`, `last_working_date`, and stint start.
 * Inactive with no last_working_date is omitted (except synthetic timesheet backfill rows).
 */
export function memberIncludedInPayrollMonth(member, monthKey) {
  if (!member || !monthKey) return false;
  const {firstDay, lastDay} = monthBounds(monthKey);
  if (!firstDay || !lastDay) return false;

  const stintStart = parseIsoDate(member.current_employment_start_date);
  if (stintStart && stintStart > lastDay) return false;

  if (member.is_currently_working !== false) return true;

  const lastWork = parseIsoDate(member.last_working_date);
  if (!lastWork) return false;

  return lastWork >= firstDay;
}

export function formatLastWorkingDateLabel(isoDate) {
  if (!isoDate) return "";
  const d = parseIsoDate(isoDate);
  if (!d) return String(isoDate);
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
